import { InlineEditField } from '@/components/shared/InlineEditField';
import { InlineSelect } from '@/components/shared/InlineSelect';
import { Panel } from '@/components/ui/panel';
import { useProjectTypes } from '@/hooks/useConfigurableLists';
import type { JobDisposition } from '@jobos/shared/types/job';

interface JobProjectInfoCardProps {
  projectType: string;
  customProjectType?: string | null;
  disposition: JobDisposition | null | undefined;
  description: string | null | undefined;
  onUpdateField: (field: string, value: any) => Promise<void>;
}

export function JobProjectInfoCard({
  projectType,
  customProjectType,
  disposition,
  description,
  onUpdateField,
}: JobProjectInfoCardProps) {
  const { data: projectTypes } = useProjectTypes();

  return (
    <Panel title="Description" className="flex-1 overflow-hidden">
        <div>
          <label className="block text-sm font-bold text-gray-700 mb-2 uppercase">
            Disposition
          </label>
          <InlineSelect
            value={disposition || 'none'}
            options={[
              { value: 'none', label: 'Not Set' },
              { value: 'awarded', label: 'Awarded' },
              { value: 'not_awarded', label: 'Not Awarded' },
            ]}
            onSave={(value) =>
              onUpdateField(
                'disposition',
                value === 'none' ? null : (value as JobDisposition)
              )
            }
          />
        </div>
        <div>
          <label className="block text-sm font-bold text-gray-700 mb-2 uppercase">
            Project Type
          </label>
          <InlineSelect
            value={projectType}
            options={projectTypes.map((type) => ({
              value: type,
              label: type,
            }))}
            onSave={async (value) => {
              await onUpdateField('projectType', value);
              // Clear custom project type when switching away from "Other"
              if (value !== 'Other') {
                await onUpdateField('customProjectType', null);
              }
            }}
          />
        </div>
        {projectType === 'Other' && (
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2 uppercase">
              Custom Service Type
            </label>
            <InlineEditField
              value={customProjectType || ''}
              onSave={(value) => onUpdateField('customProjectType', value)}
              placeholder="Enter custom service type..."
            />
          </div>
        )}
        <div className="min-w-0">
          <label className="block text-sm font-bold text-gray-700 mb-2 uppercase">
            Brief Description of Job
          </label>
          <div className="break-words overflow-hidden">
            <InlineEditField
              value={description || ''}
              onSave={(value) => onUpdateField('description', value)}
              placeholder="Add a description..."
              multiline
            />
          </div>
        </div>
    </Panel>
  );
}
